import NativeIcon from "../../../NativeIcon";
import Preview from "./Preview/Preview";


const ActionHandlerProps=[
    {
        name:"color",
        type:"string",
        description:"the color prop value",
    },
    {
        name:"element",
        type:"ActionSetActionElement",
        description:"the action HTML element",
    },
    {
        name:"ActionSetActionElement",
        type:"HTMLDivElement",
        props:[
            {
                name:"setIcon",
                type:"(icon:string|((color:string,weight=2)=>string),save?:boolean):void",
                description:`
                    you can just edit the img element src yourself, but this method will make sure that your code
                    keeps behaving the same way independently of package versions.
                `,
                props:[
                    {
                        name:"save",
                        type:"boolean",
                        description:"if true, sets the action.icon property, default to false"
                    }
                ],
            },
        ],
    }
],ActionSetDefinitionProps=[
    {
        name:"id",
        type:"string",
        required:true,
    },
    {
        name:"component",
        type:"(props:ActionSetAction&{parent:ActionSetView}:HTMLElement",
        description:"Used to add custom action component, should return a HTMLElement",
    },
    NativeIcon,
    {
        name:"size",
        type:"number",
        defaultvalue:6.4,
        description:"Icon size in em unit",
    },
    {
        name:"alt",
        type:"string",
        description:"Action image element alt attribute value",
    },
    {
        name:"onReady",
        type:"(action:ActionSetAction&{element:ActionSetActionElement,color:string}):void",
        description:"Called when the action HTMLElement is ready to click on"
    },
    {
        name:"onTrigger",
        type:"(action:ActionSetAction&{element:ActionSetActionElement,color:string}):void",
        description:"called when action element clicked",
        props:ActionHandlerProps,
        notice:"If the action was rendered using the component prop, you need to add a click event yourself",
    },
];

export const ActionSetDefinition={
    name:"ActionSetDefinition",
    type:"object",
    props:ActionSetDefinitionProps,
}

const ActionSetAction={
    name:"ActionSetAction",
    type:"string|object",
    props:[
        {
            name:"ref",type:"string",
        },
        ...ActionSetDefinitionProps,
    ],
}

export default {
    id:"ActionSetView",
    parent:{name:"View"},
    //preview:Preview,
    description:"renders a horizontal list of actions",
    cssvars:[
        {name:"spacing",type:"5em"},
    ],
    props:[
        {
            name:"definitions",
            type:"ActionSetDefinition[]",
            props:[ActionSetDefinition],
        },
        {
            name:"actions",
            type:"ActionSetAction[]",
            props:[ActionSetAction],
        },
        {
            name:"color",
            type:"string",
            description:"the value of the color param for functional icons",
        }
    ],
};
